import React, { useState, useEffect } from 'react';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';

export default function App() {
  const [user, setUser] = useState(null);
  const [accessToken, setAccessToken] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem('decodification_user');
    const token = localStorage.getItem('decodification_token');
    if (saved) {
      try { setUser(JSON.parse(saved)); } catch {}
    }
    if (token) setAccessToken(token);
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('decodification_user', JSON.stringify(userData));
    localStorage.setItem('decodification_token', token);
    setUser(userData);
    setAccessToken(token);
  };

  const handleLogout = () => {
    localStorage.removeItem('decodification_user');
    localStorage.removeItem('decodification_token');
    setUser(null);
    setAccessToken(null);
  };

  return user ? (
    <Dashboard user={user} accessToken={accessToken} onLogout={handleLogout} />
  ) : (
    <LoginPage onLogin={handleLogin} />
  );
}
